import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import RulesEngine from "@/components/RulesEngine/component";
import { Loading } from "@/components/shared/Loading";
import { useAbilities } from "@/hooks/ability/hooks";

const FormDataInjector = () => {
  const { cannot, isLoading } = useAbilities();
  const router = useNavigate();

  useEffect(() => {
    if (!isLoading && cannot("MAINTAINER")) {
      router({ to: "/" });
    }
  }, [cannot, isLoading, router]);

  return (
    <Loading isLoading={isLoading}>
      <RulesEngine />
    </Loading>
  );
};

export const Route = createFileRoute("/rules-engine/")({
  component: () => <FormDataInjector />,
});
